var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEvents({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "70%",
    height: "auto",
    viewBox: "0 0 296 262.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9313",
    "data-name": "Group 9313",
    transform: "translate(-3920 -5732)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4032",
    "data-name": "Rectangle 4032",
    width: "70%",
    height: "auto",
    transform: "translate(3920 5732)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9314",
    "data-name": "Group 9314",
    transform: "translate(3936.41 5745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17931",
    "data-name": "Path 17931",
    d: "M186.328,170.587a35.278,35.278,0,0,1,10.684,1.6V77.791c0-3.617-2.678-5.791-6.294-5.791H58.5c-3.618,0-6.5,2.174-6.5,5.791V210.01c0,3.618,2.882,7,6.5,7h91.274a50.479,50.479,0,0,1-1.031-8.558A37.777,37.777,0,0,1,186.328,170.587Z",
    transform: "translate(-0.147 -26.507)",
    fill: "#e6f2f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9285",
    "data-name": "Group 9285",
    transform: "translate(51.774 44.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9284",
    "data-name": "Group 9284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9283",
    "data-name": "Group 9283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9282",
    "data-name": "Group 9282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9281",
    "data-name": "Group 9281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9280",
    "data-name": "Group 9280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9279",
    "data-name": "Group 9279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17932",
    "data-name": "Path 17932",
    d: "M190.571,69.751H58.354a6.6,6.6,0,0,0-6.58,6.579v40.289H197.15V76.33A6.6,6.6,0,0,0,190.571,69.751Z",
    transform: "translate(-51.774 -69.751)",
    fill: "#8bbfe7"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9291",
    "data-name": "Group 9291",
    transform: "translate(69.301 55.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9290",
    "data-name": "Group 9290",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9289",
    "data-name": "Group 9289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9288",
    "data-name": "Group 9288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9287",
    "data-name": "Group 9287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9286",
    "data-name": "Group 9286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17933",
    "data-name": "Path 17933",
    d: "M123.4,112.716a10.795,10.795,0,1,1-10.793-10.8A10.792,10.792,0,0,1,123.4,112.716Z",
    transform: "translate(-101.812 -101.917)",
    fill: "#0071b9"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9297",
    "data-name": "Group 9297",
    transform: "translate(156.576 55.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9296",
    "data-name": "Group 9296",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9295",
    "data-name": "Group 9295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9294",
    "data-name": "Group 9294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9293",
    "data-name": "Group 9293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9292",
    "data-name": "Group 9292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17934",
    "data-name": "Path 17934",
    d: "M376.725,112.716a10.8,10.8,0,1,1-10.8-10.8A10.794,10.794,0,0,1,376.725,112.716Z",
    transform: "translate(-355.135 -101.917)",
    fill: "#0071b9"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9303",
    "data-name": "Group 9303",
    transform: "translate(74.67 31.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9302",
    "data-name": "Group 9302",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9301",
    "data-name": "Group 9301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9300",
    "data-name": "Group 9300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9299",
    "data-name": "Group 9299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9298",
    "data-name": "Group 9298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17935",
    "data-name": "Path 17935",
    d: "M122.622,68.139a5.488,5.488,0,0,1-5.482-5.483V36.686a5.482,5.482,0,1,1,10.965,0v25.97A5.488,5.488,0,0,1,122.622,68.139Z",
    transform: "translate(-117.14 -31.203)",
    fill: "#e6f2f8"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9309",
    "data-name": "Group 9309",
    transform: "translate(161.916 31.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9308",
    "data-name": "Group 9308",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9307",
    "data-name": "Group 9307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9306",
    "data-name": "Group 9306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9305",
    "data-name": "Group 9305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9304",
    "data-name": "Group 9304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17936",
    "data-name": "Path 17936",
    d: "M375.784,68.139a5.488,5.488,0,0,1-5.481-5.483V36.686a5.482,5.482,0,1,1,10.964,0v25.97A5.488,5.488,0,0,1,375.784,68.139Z",
    transform: "translate(-370.303 -31.203)",
    fill: "#e6f2f8"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17937",
    "data-name": "Path 17937",
    d: "M91.356,246.5a5.044,5.044,0,0,1,5.043-5.045h18.828a5.045,5.045,0,0,1,5.043,5.045v18.828a5.044,5.044,0,0,1-5.043,5.044H96.4a5.044,5.044,0,0,1-5.043-5.044V246.5Z",
    transform: "translate(-25.718 -137.65)",
    fill: "#8bbfe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17938",
    "data-name": "Path 17938",
    d: "M218.016,246.5a5.045,5.045,0,0,1,5.045-5.045h18.826a5.045,5.045,0,0,1,5.045,5.045v18.828a5.045,5.045,0,0,1-5.045,5.044H223.061a5.044,5.044,0,0,1-5.045-5.044V246.5Z",
    transform: "translate(-108.851 -137.65)",
    fill: "#8bbfe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17939",
    "data-name": "Path 17939",
    d: "M344.677,246.5a5.045,5.045,0,0,1,5.045-5.045h18.826a5.045,5.045,0,0,1,5.045,5.045v18.828a5.045,5.045,0,0,1-5.045,5.044H349.722a5.045,5.045,0,0,1-5.045-5.044V246.5Z",
    transform: "translate(-191.785 -137.65)",
    fill: "#8bbfe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17940",
    "data-name": "Path 17940",
    d: "M91.356,366.955A5.044,5.044,0,0,1,96.4,361.91h18.828a5.044,5.044,0,0,1,5.043,5.045v18.828a5.044,5.044,0,0,1-5.043,5.044H96.4a5.044,5.044,0,0,1-5.043-5.044V366.955Z",
    transform: "translate(-25.718 -216.512)",
    fill: "#8bbfe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17941",
    "data-name": "Path 17941",
    d: "M218.016,366.955a5.045,5.045,0,0,1,5.045-5.045h18.826a5.045,5.045,0,0,1,5.045,5.045v18.828a5.045,5.045,0,0,1-5.045,5.044H223.061a5.044,5.044,0,0,1-5.045-5.044V366.955Z",
    transform: "translate(-108.851 -216.512)",
    fill: "#8bbfe7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "recommendation",
    transform: "translate(144.838 138.347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9310",
    "data-name": "Group 9310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17942",
    "data-name": "Path 17942",
    d: "M398.778,366.917l-5.325,5.977a32.4,32.4,0,1,1-8.443-13.3l4.74-5.325a39.365,39.365,0,1,0,9.028,12.652Z",
    transform: "translate(-323.43 -343.54)",
    fill: "#58ab27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17943",
    "data-name": "Path 17943",
    d: "M378.653,389.443l-.7.791a6.477,6.477,0,0,0,0,8.52l.692.78s10.245,11.681,14,15.726c.283.291,1.222,1.1,1.222,1.1a3.655,3.655,0,0,0,3.714.5,3.523,3.523,0,0,0,1.277-.913l36.585-41.082a3.671,3.671,0,0,0-.03-4.887c-.081-.092-.173-.18-.265-.272s-.206-.158-.305-.247A3.673,3.673,0,0,0,430,370l-34.2,38.41Z",
    transform: "translate(-357.82 -359.942)",
    fill: "#58ab27"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.2abbdfeb.svg";
export { ForwardRef as ReactComponent };